var UTILS = require("../libs/utils.js");
var config = require("../config.js");
function Projectile() {
  this.init = function (j, k, m, p, q, u, v, w, x) {
    this.x = j;
    this.y = k;
    this.z = m;
    this.spd = u.spd;
    this.grav = u.grav;
    this.range = u.range;
    this.hitBox = u.hitB;
    p -= Math.PI;
    this.xD = p;
    this.yD = q;
    this.xS = this.spd * Math.sin(this.xD) * Math.cos(this.yD);
    this.zS = this.spd * Math.cos(this.xD) * Math.cos(this.yD);
    this.yS = this.spd * Math.sin(this.yD);
    this.dmg = u.dmg;
    this.linger = u.linger;
    this.owner = v;
    this.stateConst = v && !u.dontPred ? v.ping * 2 * v.lagComp : 0;
    this.weaponId = parseInt(w.wId);
    this.weapon = w.w;
    this.skipMove = true;
    this.eDmg = u.eDmg;
    this.expl = u.explode;
    this.nImp = u.nImp;
    this.life = u.life;
    this.stick = u.stick;
    this.active = true;
    this.src = x;
  };
  this.update = function (j) {
    if (this.active) {
      if (this.skipMove) {
        this.skipMove = false;
      } else {
        if (this.grav) {
          this.yS -= this.grav * j;
          this.spd = UTILS.getD3D(0, 0, 0, this.xS, this.yS, this.zS);
          this.yD = Math.asin(this.yS / this.spd);
        }
        this.x += this.xS * j;
        this.z += this.zS * j;
        this.y += this.yS * j;
        if (!this.life) {
          this.range -= this.spd * j;
          if (this.range <= 0) {
            this.active = false;
          }
        }
      }
    }
  };
}
module.exports = function (game, io) {
  if (!io) {
    require("three");
  }
  var m;
  var p;
  var q;
  var u = [];
  this.projectiles = [];
  this.stored = [
    {
      spd: 0.38,
      grav: 0.0002,
      spn: 0.035,
      scale: 1,
      linger: 5000,
      length: 1,
      dmg: 200,
      range: 1500,
    },
    {
      spd: 0.05,
      grav: 0,
      spn: 0.04,
      hitB: 10,
      scale: 6.1,
      length: 6.1,
      dmg: 60,
      range: 500,
    },
    {
      spd: 0.25,
      grav: 0,
      spn: 0.04,
      scale: 4,
      length: 4,
      dmg: 20,
      range: 500,
    },
    {
      spd: 0.03,
      grav: 0,
      spn: 0.04,
      hitB: 20,
      scale: 22,
      length: 22,
      dmg: 200,
      range: 600,
    },
    {
      spd: 0.25,
      grav: 0,
      spn: 0.04,
      scale: 3,
      length: 3,
      dmg: 10,
      range: 500,
    },
  ];
  this.update = function (w) {
    for (var x = 0; x < this.projectiles.length; ++x) {
      if ((m = this.projectiles[x]).active) {
        m.update(w);
        if (m.active) {
          var z = false;
          u.length = 0;
          var A = 1 / (m.spd * w * Math.sin(m.xD) * Math.cos(m.yD));
          var B = 1 / (m.spd * w * Math.cos(m.xD) * Math.cos(m.yD));
          var C = 1 / (m.spd * w * Math.sin(m.yD));
          for (var D = 0; D < game.map.manager.objects.length; ++D) {
            if (!(p = game.map.manager.objects[D]).noShoot && p.active) {
              tmpDst = UTILS.lineInRect(
                m.x,
                m.z,
                m.y,
                A,
                B,
                C,
                p.x - p.width,
                p.z - p.length,
                p.y - p.height,
                p.x + p.width,
                p.z + p.length,
                p.y + p.height,
              );
              if (tmpDst && tmpDst <= 1) {
                u.push({
                  obj: p,
                  dst: tmpDst,
                });
              }
            }
          }
          for (var E = 0; E < game.players.list.length; ++E) {
            if ((q = game.players.list[E]).active && q != m.owner) {
              p = game.players.fetchState(q, m.stateConst);
              if (m.hitBox) {
                tmpDst = UTILS.getD3D(m.x, m.y, m.z, p.x, p.y + p.h / 2, p.z);
                if (tmpDst <= m.hitBox) {
                  tmpDst /= m.hitBox;
                } else {
                  tmpDst = null;
                }
              } else {
                tmpDst = UTILS.lineInRect(
                  m.x,
                  m.z,
                  m.y,
                  A,
                  B,
                  C,
                  p.x - q.scale - config.hitBoxPad,
                  p.z - q.scale - config.hitBoxPad,
                  p.y,
                  p.x + q.scale + config.hitBoxPad,
                  p.z + q.scale + config.hitBoxPad,
                  p.y + p.h + config.hitBoxPad,
                );
              }
              if (tmpDst && tmpDst <= 1) {
                u.push({
                  plr: true,
                  obj: game.players.list[E],
                  dst: tmpDst,
                });
              }
            }
          }
          if (m.owner) {
            for (var F = 0; F < game.AI.ais.length; ++F) {
              if (game.AI.ais[F].active) {
                p = game.AI.ais[F];
                tmpDst = UTILS.lineInRect(
                  m.x,
                  m.z,
                  m.y,
                  A,
                  B,
                  C,
                  p.x - p.scale,
                  p.z - p.scale,
                  p.y,
                  p.x + p.scale,
                  p.z + p.scale,
                  p.y + p.scale * 2,
                );
                if (tmpDst && tmpDst <= 1) {
                  u.push({
                    ai: true,
                    obj: game.AI.ais[F],
                    dst: tmpDst,
                  });
                }
              }
            }
          }
          var G = game.map.terrain;
          if (G) {
            var H = G.raycast(m.x, -m.z, m.y, 1 / A, -1 / B, 1 / C);
            if (H) {
              let J = UTILS.getD3D(m.x, m.y, m.z, H.x, H.z, -H.y);
              u.push({
                dst: J / (m.spd * w),
              });
            }
          }
          if (u.length) {
            u.sort(UTILS.orderByDst);
            if (u[0]) {
              var I = m.dmg;
              if (m.owner && m.owner.smite) {
                I = 10000;
              }
              if (!u[0].plr && !u[0].ai) {
                z = true;
              }
              if (u[0].ai) {
                u[0].obj.changeHealth(-I, m.owner, m.weaponId == 12);
                if (m.owner) {
                  if (!u[0].obj.active && u[0].obj.killScore) {
                    game.players.score(m.owner, u[0].obj.killScore, true);
                  }
                  io.send(
                    m.owner.id,
                    "4",
                    u[0].obj.sid,
                    Math.round(I),
                    0,
                    !u[0].obj.active,
                    1,
                  );
                }
              } else if (
                m.owner &&
                I &&
                !game.waitTimers &&
                u[0].obj &&
                u[0].obj.health &&
                !u[0].plr
              ) {
                u[0].obj.health -= I;
                io.send(m.owner.id, "4");
                if (u[0].obj.health <= 0) {
                  u[0].obj.active = false;
                  u[0].obj.health = 0;
                  u[0].obj.destroyedBy = m.owner;
                  u[0].obj.destroyed = true;
                  game.map.manager.destObjs.push(u[0].obj.uid);
                  window.IO.broadcast("game" + game.sid, "do", u[0].obj.uid);
                  if (u[0].obj && u[0].obj.onDestroy) {
                    game.onTrigger(m.owner, u[0].obj);
                  }
                }
              }
              if (
                u[0].obj &&
                (u[0].obj.onShoot ||
                  u[0].obj.onDamage ||
                  (m.owner && m.weaponId == 12 && u[0].obj.onThrowingMelee) ||
                  u[0].obj.onProjectile)
              ) {
                game.onTrigger(m.owner, u[0].obj);
              }
              if (m.owner && u[0].obj && I && u[0].obj.isEvent) {
                game.foundEventItem(m.owner, u[0].obj);
              }
              if (
                u[0].obj &&
                I &&
                u[0].plr &&
                game.players.changeHealth(u[0].obj, m.owner, I)
              ) {
                if (m.owner && m.weaponId == 12) {
                  m.owner.tKnifeKills++;
                  if (io) {
                    game.incStat("tmk", m.owner);
                  }
                }
                game.players.kill(u[0].obj, m.owner, {
                  wId: m.weaponId,
                  w: m.weapon,
                  pj: true,
                });
              }
              u[0].dst -= 0.02;
              m.x += u[0].dst * (m.xS * w);
              m.y += u[0].dst * (m.yS * w);
              m.z += u[0].dst * (m.zS * w);
            }
            m.active = false;
          }
        }
        if (!m.active) {
          if (m.expl) {
            game.explosion(m.x, m.y, m.z, m.expl, m.eDmg, m.owner, {
              wId: m.weaponId,
              w: m.weapon,
            });
          }
          for (E = 0; E < game.players.list.length; ++E) {
            if (game.players.list[E] == m.owner) {
              io.send(
                game.players.list[E].id,
                "pre",
                m.ownShotCnt,
                1,
                m.x.round(1),
                m.y.round(1),
                m.z.round(1),
                !z || m.nImp ? 0 : 1,
              );
            } else {
              io.send(
                game.players.list[E].id,
                "pre",
                m.sid,
                0,
                m.x.round(1),
                m.y.round(1),
                m.z.round(1),
                z && !m.nImp && m.owner ? 1 : 0,
              );
            }
          }
        }
      }
    }
  };
  this.init = function (v, w, x, y, z, A, B, C, D, E) {
    y = y.round(3);
    z = z.round(3);
    v = v.round(1);
    w = w.round(1);
    x = x.round(1);
    m = null;
    for (var F = 0; F < this.projectiles.length; ++F) {
      if (!this.projectiles[F].active) {
        m = this.projectiles[F];
        break;
      }
    }
    var G;
    if (!m) {
      (m = new Projectile()).sid = this.projectiles.length;
      this.projectiles.push(m);
    }
    m.init(v, w, x, y, z, A, B, C, E);
    m.ownShotCnt = B ? B.shotCntP : null;
    if (io) {
      for (F = 0; F < game.players.list.length; ++F) {
        if (
          ((G = game.players.list[F]) != B || A.dontPred) &&
          (G.active || G.spectating)
        ) {
          if (D) {
            io.send(
              G.id,
              "pr",
              v,
              w,
              x,
              y,
              z,
              this.stored.indexOf(A),
              m.sid,
              1,
              E,
            );
          } else {
            io.send(G.id, "pr", v, w, x, y, z, B.loadout[B.weaponIndex], m.sid);
          }
        }
      }
    }
  };
};
